export default "__VITE_ASSET__B0am_18T__"